<template>
    <div class="m-portlet m-portlet--head-sm">
        <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                    <h3 class="m-portlet__head-text">
                        课程状态变更
                    </h3>
                </div>
            </div>
        </div>
        <div class="m-portlet__body infinite-list-wrapper">
            <div class="m-widget4" v-infinite-scroll="load"
                 infinite-scroll-disabled="disabled">
                <div class="m-widget4__item" v-for="item in _.orderBy($parentInfo.Task_ClassChange.data, 'isRead','asc')" :key="item.id">
                    <div class="m-widget4__info">
                        <span class="m-widget4__title">
                            <div style="display: flex;flex-direction:row; justify-content:space-between">
                                <div>{{item.new_name}}</div>
                                <div>{{item.new_time}}</div>
                                <div>{{item.new_teacher}}</div>
                            </div>
                        </span>
                        <span class="m-widget4__sub">
                             <div style="display: flex;flex-direction:row; justify-content:space-between">
                                 <div v-if="item.new_name==item.old_name">{{item.old_name}}</div>
                                 <div v-else class="different-border">{{item.old_name}}</div>
                                 <div v-if="item.new_time==item.old_time">{{item.old_time}}</div>
                                 <div v-else class="different-border">{{item.old_time}}</div>
                                 <div  v-if="item.new_teacher==item.old_teacher">{{item.old_teacher}}</div>
                                 <div v-else class="different-border">{{item.old_teacher}}</div>
                            </div>
                        </span>
                    </div>
                    <span class="m-widget4__ext" >
                        <span class="m-widget4__number m--font-brand circle"
                              :style="{'background-color':item.isRead===1?'#548057':'white'}"
                              @click="handleRead(item.id)"></span>
                    </span>
                </div>
            </div>
            <p v-if="loading">加载中...</p>
            <p v-if="noMore">没有更多了</p>
        </div>

    </div>

</template>

<script>
    export default {
        name: "Task_Refund",
        data() {
            return {
                currentPageSize:10,
                currentPage:1,
                count:10,
                loading:false,
                waiting:false,
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.$wApi.addListen(this.$parentInfo.path, this.handleData);
        },
        computed: {
            noMore () {
                return this.count === 0
            },
            disabled () {
                return this.loading || this.noMore
            }
        },
        methods: {
            handleRead(id){
                this.$wApi.send(this.$parentInfo.path, 'read_classChange', {'id':id});
            },
            handleData(event,data) {
                switch (event) {
                    case 'init_classChange':
                        this.count=data.total;
                        this.waiting = false;
                        this.loading = false;
                        break;
                }
            },
            load () {
                if(this.$parentInfo.task_scroll) {
                    this.loading = true
                    if (!this.waiting) {
                        this.currentPage++;
                        this.waiting = true
                        this.$wApi.send(this.$parentInfo.path, 'init_classChange',
                            {'currentPageSize': this.currentPageSize,
                                'currentPage': this.currentPage,
                                'semester_id':this.$parentInfo.filter.semester_id});
                    }
                }

            },
        }
    }
</script>

<style scoped>
    .infinite-list-wrapper {
        height: 300px;
        overflow: auto;
    }
    .circle{
        display:inline-block;
        margin-right:5px;
        border-radius:8px; /* 圆形边缘弧度 */
        width:16px; /* 宽度 */
        height:16px; /* 高度 */
        border:1px solid gray ;
    }
    .different-border {
        border: 1px dashed #F00;
    }
</style>
